import { useQuery } from '@tanstack/react-query'
import { fetchRegionalCandidates, candidateKeys } from '@/services/candidates'

export function useRegionalCandidates(partyId: string | undefined) {
  const candidatesQuery = useQuery({
    queryKey: candidateKeys.regionalCandidates(partyId!),
    queryFn: () => fetchRegionalCandidates(partyId!),
    enabled: !!partyId,
  })

  return {
    candidates: candidatesQuery.data,
    isLoading: candidatesQuery.isLoading,
    error: candidatesQuery.error,
  }
}
